import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import Button from '@/UIlibrary/Button/Button';
import { SyncResult } from '../../CustomerSupport/types';
import SyncStatsGrid from './SyncStatsGrid';
import FailedRecordsTable from './FailedRecordsTable';
import FailedTemplatesTable from './FailedTemplatesTable';
import SkippedTemplatesTable from './SkippedTemplatesTable';

interface SyncResultsDisplayProps {
	syncResult: SyncResult;
	isLoading: boolean;
	onRetryFailed: () => void;
	onReset: () => void;
	t: (key: string, params?: any) => string;
}

const SyncResultsDisplay: React.FC<SyncResultsDisplayProps> = ({
	syncResult,
	isLoading,
	onRetryFailed,
	onReset,
	t
}) => {
	return (
		<div className="space-y-6">
			<div className="bg-white rounded-lg shadow p-6">
				<div className="mb-4 text-green-700">
					<Typography type="display" size="sm">
						{t('SyncCompleted')}
					</Typography>
				</div>

				<SyncStatsGrid syncResult={syncResult} t={t} />

				<FailedRecordsTable
					failedRecords={syncResult.failed_records}
					isLoading={isLoading}
					onRetry={onRetryFailed}
					t={t}
				/>

				<FailedTemplatesTable failedTemplates={syncResult.failed_templates} t={t} />

				<SkippedTemplatesTable skippedTemplates={syncResult.skipped_templates} t={t} />

				<div className="flex justify-end">
					<Button onClick={onReset} label={t('SyncNewFile')} size="auto" />
				</div>
			</div>
		</div>
	);
};

export default SyncResultsDisplay;
